<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 个人设置
                </el-breadcrumb-item>
				<el-breadcrumb-item>待办事项</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择到货状态" value=""></el-option>
					<el-option key="1" label="待办" value="1"></el-option>
					<el-option key="2" label="处理中" value="2"></el-option>
					<el-option key="3" label="已处理" value="3"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="content" label="事项"></el-table-column>
                <el-table-column prop="expirationTime" label="最晚处理时间" width="160"></el-table-column>
				<el-table-column prop="status" label="状态" width="90">
					<template slot-scope="scope">
						<el-tag :type= "(scope.row.status == 3)?'success':((scope.row.status < 3 && new Date(scope.row.expirationTime).getTime() < new Date().getTime())?'danger':((scope.row.status < 3 && new Date(scope.row.expirationTime).getTime() - new Date().getTime() <  172800000)?'warning':'info'))" >{{statusFormat(null, null, scope.row.status)}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
				<el-table-column prop="createName" label="创建人" width="100"></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if = "controll['edit'] && scope.row.enableDelete && scope.row.status == 1"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-edit-outline"
                            @click="handleDeal(scope.$index, scope.row)"
							v-if = "controll['deal'] && scope.row.enableDeal && scope.row.status < 3"
                        >处理</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if = "controll['delete'] && scope.row.enableDelete"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="待办事项" prop="content">
					<el-input type=textarea :rows=5 v-model="form.content"> </el-input>
                </el-form-item>
                <el-form-item label="最晚处理时间" prop="expirationTime">
					<el-date-picker
						type="datetime"
						placeholder="请选择时间"
						v-model="form.expirationTime"
						value-format="yyyy-MM-dd HH:mm:SS"
					></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="50%">
            <el-form ref="show" :model="show" label-width="120px">
				<el-descriptions class="margin-top" title="" :column="1" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							待办事项
						</template>
						{{show.content}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							最晚处理时间
						</template>
						{{show.expirationTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							当前状态
						</template>
						{{statusFormat(null, null, show.status)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							处理结论
						</template>
						{{show.deal}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							处理时间
						</template>
						{{show.dealTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							创建时间
						</template>
						{{show.createTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							创建人
						</template>
						{{show.createName}}
					</el-descriptions-item>
				</el-descriptions>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">取 消</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="处理待办事项" :visible.sync="dealVisible" width="50%">
            <el-form ref="form" :model="form" label-width="120px" :rules="dealRules">
				<el-form-item label="待办事项">
					{{form.content}}
                </el-form-item>
				<el-form-item label="当前状态" prop="status">
					<el-select v-model="form.status" placeholder="请选择状态" >
						<el-option key="" label="请选择状态" value=""></el-option>
						<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="处理结论" prop="deal">
					<el-input type=textarea :rows=5 v-model="form.deal"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dealVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchToDoListDataByHandler, saveToDoList, deleteToDoList, getToDoList } from '../../../api/index';
import bus from '../../common/bus';
export default {
    name: 'my-todo-list',
    data() {
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
			showVisible: false,
            pageTotal: 0,
            form: {},
			show:{},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			deal:{},
			dealVisible:false,
			rules: {
                content: [{ required: true, message: '请输入待办事项', trigger: 'blur' }],
				expirationTime: [{ required: true, message: '请选择最晚处理时间', trigger: 'blur' }]
            },
			dealRules: {
                status: [{ required: true, message: '请选择当前处理状态', trigger: 'blur' }],
				deal: [{ required: true, message: '请输入处理结论', trigger: 'blur' }]
            },
			statusKV:[{"key":1,"value":"待办"},{"key":2,"value":"处理中"},{"key":3,"value":"已处理"}],
			controll:{}
        };
    },
    created() {
		this.controll = getControll("my-todo-list");
        this.getData();
		bus.$on('todoListRefresh', msg => {
            this.getData();
        });
    },
    methods: {
		statusFormat(row, column, cellValue) {
			let statusConfig = {"1":"待办", "2":"处理中", "3":"已处理","4":"已撤销"};
			return statusConfig[cellValue];
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchToDoListDataByHandler(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteToDoList([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteToDoList(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
           this.getDataById(row.id, 0);
        },
		// 处理操作
		handleDeal(index, row) {
			this.getDataById(row.id, 1);
		},
		// 通过id获取数据
		getDataById(id, visibleType) {
			getToDoList(id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					if (visibleType == 0) {
						this.editVisible = true;
					} else {
						this.dealVisible = true;
					}
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		//详情操作
		handleShow(index, row) {
			this.idx = index;
			this.show = row;
			this.showVisible = true;
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveToDoList(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.dealVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
